// Central data for services, gallery, testimonials

export const SERVICES = [
  {
    key: "residential",
    title: "Residential Deep Cleaning",
    desc: "Whole-home deep cleaning that removes dust, grime and buildup from every corner.",
    icon: "Home",
    image: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?auto=format&fit=crop&w=900&q=70",
  },
  {
    key: "commercial",
    title: "Commercial Deep Cleaning",
    desc: "Office, retail and workspace cleaning that keeps your business spotless and healthy.",
    icon: "Building2",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=900&q=70",
  },
  {
    key: "move",
    title: "Move-In / Move-Out Cleaning",
    desc: "Deep-clean handovers for renters, landlords and homebuyers — leave nothing but shine.",
    icon: "Truck",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=900&q=70",
  },
  {
    key: "post-construction",
    title: "Post-Construction Cleaning",
    desc: "Dust, debris, paint splatter — we bring newly built or renovated spaces to move-in ready.",
    icon: "HardHat",
    image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=900&q=70",
  },
  {
    key: "kitchen",
    title: "Kitchen & Appliance Cleaning",
    desc: "Degrease hoods, ovens, stovetops and cabinets — food-safe, sparkling surfaces.",
    icon: "ChefHat",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=900&q=70",
  },
  {
    key: "bathroom",
    title: "Bathroom & Grout Cleaning",
    desc: "Grout restoration, tile scrubbing, limescale removal and sanitization.",
    icon: "Droplets",
    image: "https://images.unsplash.com/photo-1714058973555-a255930b9a39?auto=format&fit=crop&w=900&q=70",
  },
  {
    key: "duct",
    title: "Duct & Ventilation Cleaning",
    desc: "Breathe easier — deep clean of ducts, vents and filters for healthier indoor air.",
    icon: "Wind",
    image: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?auto=format&fit=crop&w=900&q=70",
  },
  {
    key: "eco",
    title: "Eco-Friendly Sanitization",
    desc: "Non-toxic, plant-based products safe for kids, pets and sensitive spaces.",
    icon: "Leaf",
    image: "https://images.unsplash.com/photo-1759846866217-e627e4478f82?auto=format&fit=crop&w=900&q=70",
  },
];

export const ROOMS = [
  {
    key: "kitchen",
    title: "Kitchen",
    desc: "Countertops, backsplashes, hoods, appliances (in & out), sinks, faucets, and cabinet fronts.",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=900&q=70",
  },
  {
    key: "bathroom",
    title: "Bathroom",
    desc: "Tile & grout deep clean, tubs, showers, mirrors, fixtures, toilet sanitization.",
    image: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&w=900&q=70",
  },
  {
    key: "duct",
    title: "Duct System",
    desc: "Vents, return grilles, ducts and filters cleaned to reduce dust and allergens.",
    image: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?auto=format&fit=crop&w=900&q=70",
  },
  {
    key: "living",
    title: "Living Areas",
    desc: "Floors, upholstery, blinds, baseboards, light fixtures, and full dust removal.",
    image: "https://images.unsplash.com/photo-1609081144289-eacc3108cd03?auto=format&fit=crop&w=900&q=70",
  },
];

export const GALLERY = [
  {
    id: "g1",
    category: "Kitchen",
    before: "https://images.unsplash.com/photo-1649954596857-1e8c87d53ae3?auto=format&fit=crop&w=1200&q=70",
    after: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=1200&q=70",
  },
  {
    id: "g2",
    category: "Bathroom",
    before: "https://images.unsplash.com/photo-1620662736427-b8a198f52a4d?auto=format&fit=crop&w=1200&q=70",
    after: "https://images.unsplash.com/photo-1714058973555-a255930b9a39?auto=format&fit=crop&w=1200&q=70",
  },
  {
    id: "g3",
    category: "Ducts",
    before: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&w=1200&q=70",
    after: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?auto=format&fit=crop&w=1200&q=70",
  },
  {
    id: "g4",
    category: "Floor",
    before: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=1200&q=70",
    after: "https://images.unsplash.com/photo-1609081144289-eacc3108cd03?auto=format&fit=crop&w=1200&q=70",
  },
  {
    id: "g5",
    category: "Move-Out",
    before: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=1200&q=70",
    after: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?auto=format&fit=crop&w=1200&q=70",
  },
  {
    id: "g6",
    category: "Kitchen",
    before: "https://images.unsplash.com/photo-1556908114-f6e7ad7d0000?auto=format&fit=crop&w=1200&q=70",
    after: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=1200&q=70",
  },
];

export const TESTIMONIALS = [
  {
    name: "Priya Sharma",
    role: "Homeowner, Bangalore",
    quote:
      "The team transformed our kitchen and bathrooms. Every corner looks brand new — and they were on time, polite, and thorough.",
    rating: 5,
    photo: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=300&q=70",
  },
  {
    name: "Rahul Verma",
    role: "Office Manager",
    quote:
      "We hired them for our office post-renovation clean. Dust, paint marks, and grime — all gone. Professional and reliable.",
    rating: 5,
    photo: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=300&q=70",
  },
  {
    name: "Aditi Menon",
    role: "New Homeowner",
    quote:
      "Move-in cleaning was a lifesaver. Spotless from floor to ceiling. Highly recommended for anyone shifting homes.",
    rating: 5,
    photo: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=300&q=70",
  },
];

export const GALLERY_TABS = ["All", "Kitchen", "Bathroom", "Ducts", "Floor", "Move-Out"];

export const SERVICE_OPTIONS = SERVICES.map(s => s.title);
export const PROPERTY_TYPES = ["Apartment", "Villa / Independent House", "Office", "Retail Store", "Restaurant", "Other"];
export const TIME_SLOTS = ["Morning (8 AM – 11 AM)", "Midday (11 AM – 2 PM)", "Afternoon (2 PM – 5 PM)", "Evening (5 PM – 8 PM)"];

export const WHATSAPP_NUMBER = "9591047563";
export const OWNER_EMAIL = "vinaykvg12@gmail.com";
